/**
 * Environment-scoped token storage — matches courtyard dashboard `utils/tokenStorage.ts`.
 * Backend `get_current_user` validates Firebase ID tokens only; store the same token shape as the web app.
 */

export function getEnvironment(): 'development' | 'production' {
  return process.env.NODE_ENV === 'production' ? 'production' : 'development';
}

const getTokenKey = (): string => `auth_token_${getEnvironment()}`;

const getUserKey = (): string => `auth_user_${getEnvironment()}`;

export function getToken(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(getTokenKey());
}

export function setToken(token: string): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(getTokenKey(), token);
}

export function removeToken(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(getTokenKey());
}

export function getUser(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(getUserKey());
}

export function setUser(user: string): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(getUserKey(), user);
}

export function removeUser(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(getUserKey());
}

export function clearAuthData(): void {
  removeToken();
  removeUser();
  if (typeof window === 'undefined') return;
  localStorage.removeItem('google_access_token');
  localStorage.removeItem('google_authenticated_email');
}

export function migrateOldToken(): void {
  if (typeof window === 'undefined') return;

  const oldToken = localStorage.getItem('authToken');
  const oldUser = localStorage.getItem('auth_user');

  if (oldToken && !getToken()) {
    setToken(oldToken);
    if (oldUser) setUser(oldUser);
  }
  if (oldToken) {
    localStorage.removeItem('authToken');
    localStorage.removeItem('auth_user');
  }
}

export function initializeTokenStorage(): void {
  migrateOldToken();
}
